"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Sentence_1 = __importDefault(require("./Sentence"));
const styles_1 = require("./styles");
/*
  An <AddOn /> is a component composed of one or more sentences. Each sentence may or may not trigger a <Modal />.
*/
const AddOn = ({ content, addOnType, onTrack }) => {
    return (react_1.default.createElement(styles_1.AddOnContainer, null, content.map(({ sentence, hasModal, modalContent }) => {
        return (react_1.default.createElement(Sentence_1.default, { addOnType: addOnType, key: sentence, sentence: sentence, hasModal: hasModal, modalContent: modalContent, onTrack: onTrack }));
    })));
};
AddOn.propTypes = {
    content: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        sentence: prop_types_1.default.string,
        hasModal: prop_types_1.default.bool,
        modalContent: prop_types_1.default.shape({
            title: prop_types_1.default.string,
            body: prop_types_1.default.arrayOf(prop_types_1.default.string)
        })
    })).isRequired,
    addOnType: prop_types_1.default.string.isRequired,
    /** signature onTrack(eventName: string, eventData = {[key:string]:string}) */
    onTrack: prop_types_1.default.func
};
exports.default = AddOn;
//# sourceMappingURL=AddOn.js.map